import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState, store } from './store';
import { Edit } from './MiscSlice';
import { Afr, Period } from './AfrSlice';
import http from '../utils/http';

export enum TaxonomyTypeEnum {
    AFR = 'AFR',
    COURT_REPORTING = 'COURT_REPORTING',
    COURT_REPORTING_939 = 'COURT_REPORTING_939',
    COURT_REPORTING_29 = 'COURT_REPORTING_29',
    DEPARTMENT = 'DEPARTMENT',
    BASE = "BASE"
}
export enum LogicalPeriodEnum {
    ANNUAL = "ANNUAL",
    Q_1 = "Q_1",
    Q_2 = "Q_2",
    Q_3 = "Q_3",
    Q_4 = "Q_4"
}
export interface VersionRef {
    type: TaxonomyTypeEnum;
    year: number;
}
export interface TaxonomyVersionInfo {
    year: number;
    type: TaxonomyTypeEnum | null;
    periods: Period[] | null;
    isPublished: boolean;
}
export interface ActiveTaxonomyVersionInfo {
    year: number;
    type: TaxonomyTypeEnum | null;
    periods: Period[] | null;
    isPublished : boolean;
    id: string;
}
export interface TaxonomyVersionState {
    edit: Edit;
    version: ActiveTaxonomyVersionInfo | null;
    availableVersions: Array<TaxonomyVersionInfo> | null;
    status: 'idle' | 'loading' | 'failed';
}

const initialState: TaxonomyVersionState = {
    edit: { IsDirty: false, Page: "" },
    version: null,
    availableVersions: null,
    status: 'idle'
}
export const getReferenceForVersion = function (versionInfo : ActiveTaxonomyVersionInfo | null, yr : number): VersionRef {
    var tt: TaxonomyTypeEnum = TaxonomyTypeEnum.AFR;
    var taxYear = yr;
    if (versionInfo && versionInfo.type) {
        tt = versionInfo.type
        if (yr < 0) {
            taxYear = versionInfo.year;
        }
    }
    var result: VersionRef = {
        type: tt,
        year: taxYear
    }
    return result;
}
export const getReferenceForBasicVersion = function (versionInfo: TaxonomyVersionInfo | null, yr: number): VersionRef {
    var tt: TaxonomyTypeEnum = TaxonomyTypeEnum.AFR;
    var taxYear = yr;
    if (versionInfo && versionInfo.type) {
        tt = versionInfo.type
        if (yr < 0) {
            taxYear = versionInfo.year;
        }
    }
    var result: VersionRef = {
        type: tt,
        year: taxYear
    }
    return result;
}
export const getTaxonomyReferenceForAfr = function (a : Afr | null): VersionRef {
    var tt: TaxonomyTypeEnum = TaxonomyTypeEnum.AFR;
    if (a && a.taxonomyType) {
        tt = a.taxonomyType
    }
    var taxYear: number = a ? a.year : 2022;
    var result: VersionRef = {
        type: tt,
        year: taxYear
    }
    return result;
}
export const getAllTaxonomyVersions = createAsyncThunk(
    "Taxonomy/GetAllVersions",
    async (types: string | null): Promise<TaxonomyVersionInfo[]> => {
        try {
            if (!types) {
                types = "AFR";
            }
            const result = await http<string[], TaxonomyVersionInfo[]>({
                path: `/taxonomy/allVersions/${types}`,
            });
            if (result.ok && result.parsedBody) {
                return result.parsedBody;
            }
            else {
                return [];
            }
        } catch (ex) {
            return [];
        }
    });

export const refreshTaxonomyCaches = createAsyncThunk(
    "Taxonomy/GetAllVersions",
    async (types: string | null): Promise<TaxonomyVersionInfo[]> => {
        try {
            if (!types) {
                types = "AFR";
            }
            const result = await http<string[], TaxonomyVersionInfo[]>({
                path: `/taxonomy/refreshTaxonomyCaches/${types}`,
            });
            if (result.ok && result.parsedBody) {
                return result.parsedBody;
            }
            else {
                return [];
            }
        } catch (ex) {
            return [];
        }
    });


export const taxonomyVersionSlice = createSlice({
    name: 'TaxonomyVersion',
    initialState,
    reducers: {
        setIsTaxonomyDirty: (state: any, action: any) => {
            if (!action.payload.IsDirty) {
                state.edit = initialState.edit
            } else {
                state.edit = action.payload;
            }
        },
        setTaxonomyVersion: (state: any, action: any) => {
            state.version = action.payload;
        },

    },
    extraReducers: (builder: any) => {
        builder
            .addCase(getAllTaxonomyVersions.pending, (state: any) => {
                state.status = "loading";
            })
            .addCase(getAllTaxonomyVersions.fulfilled, (state: any, action: any) => {
                state.availableVersions = action.payload;
                state.status = "idle";
            })
    },
});

export const { setIsTaxonomyDirty, setTaxonomyVersion } = taxonomyVersionSlice.actions;

export const getTaxonomyVersion = (state: RootState) => state.taxonomyVersion ? state.taxonomyVersion : null;

export const selectCurrentVersion = (state: RootState) => state.taxonomyVersion ? state.taxonomyVersion.version : null;

export const selectAvailableVersions = (state: RootState) => (state.taxonomyVersion && state.taxonomyVersion.availableVersions) ? state.taxonomyVersion.availableVersions : [];

export const isTaxonomyDirty = (state: RootState) => state.taxonomyVersion ? state.taxonomyVersion.edit.IsDirty : false;

export default taxonomyVersionSlice.reducer;